/**
 * You can register global mixins here
 */
import User from "@/service/user.js"
const GlobalMixins = {
  install(Vue) {
    Vue.mixin({
      mounted() {
        let { bodyClass } = this.$options;
        if (bodyClass) {
          document.body.classList.add(bodyClass);
        }
      },
      beforeDestroy() {
        let { bodyClass } = this.$options;
        if (bodyClass) {
          document.body.classList.remove(bodyClass);
        }
      },
      methods: {
        check_user_login() {
          let user = new User()
          if (!this.$store.state.user.userinfo.id) {
            if (user.check_is_wxc_domain() || user.check_is_wxcblog_domain() ){
              //文学城跳转
              var redirect = encodeURIComponent(window.location.href);
              window.location.href = 'https://www.wenxuecity.com/members/passport.php?act=login&redirect='+redirect;
            }else{
              //海外跳转
              this.$router.push({path:"/login",query:{redirect: this.$route.fullPath}})
            }
            return false
          }
          return true
        },

        loadmore(article,lastkey="create_date",size=19){
          // if(article.length===0){
          //   return
          // };
          this.noMore = article.length < size ? true : false;
          this.lastID=(article[article.length-1]==undefined)?0:article[article.length-1]['postInfo_postID'][lastkey]
        },
      }
    });
  }
};

export default GlobalMixins;
